<template>
  <v-dialog v-model="dialog" max-width="80%" persistent>
      <v-card>
            <v-card-title class="pa-1">
                <v-col cols="12" class="pa-0 text-right">
                    <v-btn icon color="primary" @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" class="pa-0 text-center">
                    <h1>Histórico de edições</h1>
                </v-col>
            </v-card-title>
            
            <v-card-text class="py-0">
                <v-row>
                    <v-col cols="12" class="py-1">
                        <v-data-table 
                            dense
                            :headers="headers" 
                            :items="historico" 
                            :page.sync="page"
                            :items-per-page="10"
                            @page-count="pageCount = parseInt($event, 10)"
                            hide-default-footer
                        >
                            
                            <template v-slot:item.dt_alteracao="{item}">
                                {{item.data_alteracao | formatDate}}
                                
                            </template>

                            <template v-slot:item.acao="{item}">
                                {{ item.acao }}                                
                            </template>

                            <template v-slot:item.alteracao="{item}">
                                
                                <v-menu left offset-x :nudge-width="250" max-width="250px">

                                    <template v-slot:activator="{ on, attrs }" >
                                        
                                        <span class="py-2" v-html="item.alteracao.substring(0, 50)"></span>

                                        <v-btn v-bind="attrs"  v-on="on" small icon class="pa-1 ma-1">
                                            <v-icon small color="primary" class="ma-0">fa-ellipsis-h</v-icon >
                                        </v-btn>

                                    </template>

                                        <v-card>
                                            <v-card-text>
                                                
                                                <span class="py-2" v-html="item.alteracao"></span>

                                            </v-card-text>
                                        </v-card>
                            
                                </v-menu>
                            </template>

                            <template v-slot:item.username_alteracao="{item}">
                                 <span class="py-2" v-html="item.username_alteracao"></span>
                            </template>

                        </v-data-table>
                    </v-col>
                    <v-col class="pa-0" cols="12">
            <v-pagination class="no-box-shadow" v-model="page" :length="pageCount"></v-pagination>
        </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-center py-5">
                <v-btn
                    color="primary"
                    height="30px"
                    small
                    depressed
                    @click="close()"
                >Fechar
                </v-btn>
            </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment"
export default {
    data() {
        return {
            acaoEnum:{
                EdicaoDeItem: 'Edição de Item',
                EdicaoDeGuia: 'Edição de Guia',
                EdicaoEmMassaguia: 'Edição em Massa de Guias',
                EdicaoEmMassaitem: 'Edição em Massa de Itens',
            },
            headers: [
                { text: "Data", value: "dt_alteracao", sortable: false, width: '160px' },
                { text: "Ação", value: "acao", sortable: false },
                { text: "Descrição", value: "alteracao", sortable: false },
                { text: "Usuário", value: "username_alteracao", sortable: false },
            ],
            page: 1,
            pageCount: 1
        }
    },
    filters: {
        formatDate(date) {
            return moment(date).format("L [às] HH:mm:ss");
        },
        //formatDate(date) {
        //  return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h'
        //},
    },
    props: {
        dialog: Boolean,
        close: Function,
        historico: Array
    },

}
</script>

<style>

</style>